import { toast } from "react-toastify";
import ApiService from "./api";
import { iPaymentDetails } from "core/kangarooTypes/iPaymentDetails";
import { iResponse } from "core/kangarooTypes/iResponse";
import { formatDate } from "date-fns";

export const downloadPaymentsInvoice = (paymentId: number): Promise<void> => {
  return ApiService.fetchData({
    url: `generate-invoice/${paymentId}`, // Assuming there's an export endpoint
    method: "GET",
    responseType: "blob", // Important: We need to handle binary data
  })
    .then((response) => {
      // Create a URL for the blob
      const url = window.URL.createObjectURL(
        new Blob([response], { type: "application/pdf" })
      );

      // Create a temporary link element
      const link = document.createElement("a");
      link.href = url;

      // Set the file name (you might want to get this from headers)
      link.setAttribute(
        "download",
        `payments-invoice-${new Date().toISOString().split("T")[0]}.pdf`
      );

      // Append to body, click, and clean up
      document.body.appendChild(link);
      link.click();
      window.URL.revokeObjectURL(url);
      document.body.removeChild(link);
    })
    .catch((error) => {
      toast.error("Failed to download payments invoice.");
    });
};

export const getPaymentDetails = (
  paymentId: string
): Promise<iResponse<iPaymentDetails>> => {
  return ApiService.fetchData({
    url: `payments/${paymentId}`,
    method: "GET",
  });
};

export const addPayment = (data: {
  merchant_id: number;
  order_ids: number[];
}): Promise<any> => {
  return ApiService.fetchData({
    url: `payments`,
    method: "POST",
    data: {
      date: formatDate(new Date(), "dd/MM/yyyy"),
      merchant_id: data.merchant_id,
      order_ids: data.order_ids,
    },
  });
};

export const setAsPaid = (paymentId: number): Promise<any> => {
  return ApiService.fetchData({
    url: `payments/${paymentId}`,
    method: "POST",
    data: {},
  });
};
export const addImagesToPayment = (
  paymentId: number,
  files: File[]
): Promise<any> => {
  const formData = new FormData();
  if (files) {
    files.forEach((file) => {
      formData.append("images[]", file);
    });
  }
  return ApiService.fetchData({
    url: `payments-images/${paymentId}`,
    method: "POST",
    data: formData,
  });
};
